"use client";

import { FormEvent, useState } from "react";

type Props = {
  endpoint: string;
  payload: Record<string, unknown>;
  buttonLabel: string;
  successMessage: string;
  source?: string;
  compact?: boolean;
};

export function EmailCaptureForm({
  endpoint,
  payload,
  buttonLabel,
  successMessage,
  source = "nichemrr-site",
  compact = false
}: Props) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          source,
          ...payload
        })
      });

      const body = await response.json() as { details?: string; error?: string };

      if (!response.ok) {
        throw new Error(body.details ?? body.error ?? "Request failed.");
      }

      setSuccess(successMessage);
      setEmail("");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Unable to submit.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form onSubmit={onSubmit} className={compact ? "newsletter-form newsletter-form--compact" : "newsletter-form"}>
      <input
        type="email"
        className="form-input newsletter-input"
        placeholder="you@buildsaas.com"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
        required
      />
      <button type="submit" className="btn btn--primary" disabled={submitting}>
        {submitting ? "Working..." : buttonLabel}
      </button>
      {success && <div className="newsletter-success newsletter-success--inline">{success}</div>}
      {error && <div className="error-inline">{error}</div>}
    </form>
  );
}
